<template>
  <div
    ref="getMoreButton"
    class="moreItems moreToGet"
    style="padding-top: 5px;"
    @click="raiseGetMore"
  >
    {{ label }}
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'GetMoreButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    preventAutoScroll: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      isMounted: false,
    }
  },
  computed: {
    ...mapState({
      scrollTop: state => state.appFrame.scrollTop,
      windowHeight: state => state.appFrame.windowHeight,
      windowWidth: state => state.appFrame.windowWidth,
    }),
    isVisible: function () {
      if (this.isMounted) { // note that $refs don't exist until after the initial render of the component
        const buttonPos = this.$refs.getMoreButton.getBoundingClientRect().top // + this.$refs.getMoreButton.offsetHeight
        return this.windowHeight + this.scrollTop > buttonPos + this.scrollTop && buttonPos > 0
      } else {
        return false
      }
    },
  },
  watch: {
    isVisible: function (value) {
      if (value && this.windowWidth > 1023 && !this.preventAutoScroll) {
        this.raiseGetMore()
      }
    },
  },
  mounted: function () {
    this.isMounted = true
  },
  methods: {
    raiseGetMore: function () {
      this.$emit('getMore')
    },
  },
}

</script>
